import './App.css';

import { useState, useEffect, useRef } from 'react';
import { initializeApp } from 'firebase/app';
import {
  getFirestore, collection, query, orderBy, where,
  addDoc, serverTimestamp, Timestamp, doc, setDoc,
  getDocs, writeBatch
} from 'firebase/firestore';
import { getAuth, signInAnonymously } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useCollection } from 'react-firebase-hooks/firestore';

const app = initializeApp({
  apiKey: "AIzaSyDWH-4voAtQSKnzyIEfvrMd-LW4NnhTYFA",
  authDomain: "tebchat-7df99.firebaseapp.com",
  projectId: "tebchat-7df99",
  storageBucket: "tebchat-7df99.firebasestorage.app",
  messagingSenderId: "760780153441",
  appId: "1:760780153441:web:019a6600398047ef018020"
});

const auth = getAuth(app);
const firestore = getFirestore(app);

const TWO_HOURS = 2 * 60 * 60 * 1000;

function App() {
  const [nick, setNick] = useState('');
  const [member, setMember] = useState(false);
  const [nickInput, setNickInput] = useState('');
  const [codeInput, setCodeInput] = useState('');
  const [error, setError] = useState('');
  const [authUser, authLoading] = useAuthState(auth);

  useEffect(() => {
    if (!authLoading && !authUser) signInAnonymously(auth).catch(console.error);
  }, [authLoading, authUser]);

const join = async (e) => {
  e.preventDefault();
  const n = nickInput.trim().slice(0, 20);
  if (!n || n.toUpperCase() === 'SYSTEM' || !authUser) return;
  try {
    await setDoc(doc(firestore, 'members', authUser.uid), { code: codeInput.trim() });
    setNick(n);
    setMember(true);
    setError('');

    await addDoc(collection(firestore, 'messages'), {
      text: `${n} dołączył`,
      user: 'SYSTEM',
      uid: authUser.uid,
      createdAt: serverTimestamp(),
      expireAt: Timestamp.fromMillis(Date.now() + TWO_HOURS),
    });
  } catch (err) {
    console.error('Błąd zapisu:', err.code, err.message);
    setError('Zły kod dostępu');
  }
};

  const leave = () => {
    setMember(false);
    setNick('');
    setNickInput('');
    setCodeInput('');
  };

  return (
    <div className="App">
      <section>
        {!authUser ? (
          <p></p>
        ) : !(member && nick) ? (
          <form onSubmit={join} id="loginForm">
            <h1>psssssst....</h1>
            <input
              value={nickInput}
              onChange={e => setNickInput(e.target.value)}
              placeholder="Nazwa"
              maxLength={20}
            />
            <input
              value={codeInput}
              onChange={e => setCodeInput(e.target.value)}
              placeholder="Kod dostępu"
              type="password"
            />
            <button type="submit">Zaloguj się</button>
            {error && <p style={{ color: 'red' }}>{error}</p>}
          </form>
        ) : (
          <ChatRoom nick={nick} uid={authUser.uid} onDenied={leave} onLogout={leave} />
        )}
      </section>
    </div>
  );
}

function ChatMessage({ message }) {
  return <p><b>{message.user}:</b> {message.text}</p>;
}

function ChatRoom({ nick, uid, onDenied, onLogout }) {
  const messagesRef = collection(firestore, 'messages');

  const [since, setSince] = useState(() => Timestamp.fromMillis(Date.now() - TWO_HOURS));
  useEffect(() => {
    const id = setInterval(
      () => setSince(Timestamp.fromMillis(Date.now() - TWO_HOURS)),
      10000
    );
    return () => clearInterval(id);
  }, []);

  const q = query(messagesRef, where('createdAt', '>', since), orderBy('createdAt'));
  const [snapshot, loading, error] = useCollection(q);
  const [text, setText] = useState('');
  const bottomRef = useRef(null);

  useEffect(() => {
    if (error?.code === 'permission-denied') onDenied();
  }, [error, onDenied]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [snapshot]);

  const send = async (e) => {
    e.preventDefault();
    const t = text.trim();
    if (!t) return;
    setText('');
    try {
      await addDoc(messagesRef, {
        text: t.slice(0, 500),
        user: nick,
        uid,
        createdAt: serverTimestamp(),
        expireAt: Timestamp.fromMillis(Date.now() + TWO_HOURS),
      });
    } catch (err) {
      console.error('Nie udało się wysłać:', err);
    }
  };

  const clearChat = async () => {
    if (!window.confirm('Wyczyścić czat dla wszystkich?')) return;
    try {
      const snap = await getDocs(collection(firestore, 'messages'));
      const batch = writeBatch(firestore);
      snap.docs.forEach(d => batch.delete(d.ref));
      await batch.commit();

      await addDoc(collection(firestore, 'messages'), {
        text: `${nick} wyczyścił czat`,
        user: 'SYSTEM',
        uid,
        createdAt: serverTimestamp(),
        expireAt: Timestamp.fromMillis(Date.now() + TWO_HOURS),
      });
    } catch (err) {
      console.error('Nie udało się wyczyścić czatu:', err);
    }
  };

  return (
    <div className="chat-wrapper">
      <div className="topbar">
        <p>Nazwa: <b>{nick}</b></p>
        <button onClick={onLogout} type="button">Wyloguj</button>
        <button onClick={clearChat} type="button">Wyczyść czat</button>
      </div>

      <div className="chat-body">
        {loading && <p>Ładowanie</p>}
        {error && <p style={{ color: 'red' }}>Błąd: {error.message}</p>}

        <div className="messages">
          {snapshot?.docs.map(d => (
            <ChatMessage key={d.id} message={d.data()} />
          ))}
          <div ref={bottomRef} />
        </div>

        <form onSubmit={send}>
          <input
            value={text}
            onChange={e => setText(e.target.value)}
            placeholder="Napisz wiadomość"
          />
          <button type="submit" disabled={!text.trim()}>Wyślij</button>
        </form>
      </div>
    </div>
  );
}

export default App;